import { Injectable } from '@angular/core';
import { Persona } from '@core/configs/persona';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  WEB_DISABLED_FEATURE = [
    24 // Tranport Management
  ]

  constructor() { }

  setUserProfile(userProfile) {
    localStorage.setItem('userProfile', JSON.stringify(userProfile))
  }

  setUserFeature(modules) {
    let modulesFiltered = []
    modules.forEach(m => {
      let featuresFiltered = []
      const {module_id, module_name, features} = m
      if(features) {
        features.forEach(f => {
          if(!this.WEB_DISABLED_FEATURE.includes(f.id)) {
            featuresFiltered.push(f)
          }
        })
      }
      if(featuresFiltered.length) {
        const module = {
          module_id,
          module_name,
          features: featuresFiltered
        }
        modulesFiltered.push(module)
      }
    })
    localStorage.setItem('userFeatures', JSON.stringify(modulesFiltered))
  }

  getUserProfile() {
    const userProfile = localStorage.getItem('userProfile');
    if (userProfile) {
      return JSON.parse(userProfile);
    }
    return null;
  }

  getUserFeatures() {
    const userFeatures = localStorage.getItem('userFeatures');
    if (userFeatures) {
      return JSON.parse(userFeatures);
    }
    return null;
  }

  getUserLang() {
    const lang = localStorage.getItem('userLang') || 'en';
    return lang
  }

  getUserCompany() {
    const profile = this.getUserProfile();
    if(!profile) {
      return null;
    }
    const { company } = profile;
    return company
  }

  getUserCompanyId() {
    const company = this.getUserCompany();
    if(!company) {
      return null;
    }
    const companyId = company.id;
    return companyId;
  }

  getUserCompanyIdentifier() {
    const company = this.getUserCompany();
    if(!company) {
      return null;
    }
    const companyIdentifier = company.identifier;
    return companyIdentifier
  }

  getUserEmail() {
    const profile = this.getUserProfile();
    if(!profile) {
      return null;
    }
    const { contact_email } = profile;
    return contact_email
  }

  isAdmin() {
    const profile = this.getUserProfile();
    if(!profile) {
      return false;
    }
    const { is_admin } = profile;
    return is_admin;
  }

  checkPersonaExist(persona: Array<number> | number) {
    const profile = this.getUserProfile();
    let isExist = false;
    if(!profile || !profile.company || !Array.isArray(profile.company.personas)) {
      return isExist;
    }
    const { personas } = profile.company;
    let dataCompare: Array<number> = []
    if(typeof persona === 'number') {
      dataCompare = [persona]
    } else {
      dataCompare = persona
    }
    personas.forEach(per => {
      if(dataCompare.includes(per.id)) {
        isExist = true;
      }
    })
    return isExist;
  }

  hasTruckingPersona() {
    return this.checkPersonaExist(Persona.TRUCKING_COMPANY);
  }

  hasCarrierPersona() {
    return this.checkPersonaExist(Persona.CARRIER);
  }

  hasFlowCreatorPersona() {
    const flowCreatorPersona = [Persona.LOGISTICS_SERVICE_PROVIDER, Persona.FREIGHT_FORWARDER, Persona.SHIPPER];
    return this.checkPersonaExist(flowCreatorPersona);
  }
}
